// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._2yJSj{display:flex;justify-content:space-between;align-items:center;opacity:1}._32hna{opacity:0.6}._3T1xJ{display:flex;flex-direction:column}.tZDlY{text-decoration:none}._3jUZT{text-decoration:line-through}\n", ""]);
// Exports
exports.locals = {
	"box": "_2yJSj",
	"box__emptyStock": "_32hna",
	"row": "_3T1xJ",
	"label": "tZDlY",
	"label__emptyStock": "_3jUZT"
};
module.exports = exports;
